<template>
  <div class="settings-block settings-block--title-only">
    <div class="settings-block__title">
      <div class="settings-block__title-text">
        {{ t('Password') }}
      </div>
      <div class="settings-block__title-buttons">
        <ui-button
          :text="t('Change Password')"
          icon="fas fa-key"
          button-style="outline-accent"
          @click="changePassword"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import { $emitter } from '@/services/emitter';

const { t } = useI18n();

const changePassword = () => {
  $emitter.emit('open-dialog', { name: 'ChangePassword' });
};
</script>

<style lang="scss" scoped>
</style>
